import script from "./uploadApplication.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadApplication.vue?vue&type=script&lang=ts&setup=true"

import "./uploadApplication.vue?vue&type=style&index=0&id=505ed9e2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505ed9e2"]])

export default __exports__